import { useStore } from 'react-redux';
import { useCallback } from 'react';
import { IApplicationState } from '../types/redux';

/**
 * Хук для получения актуального значения из Redux store в любой момент времени.
 * В отличие от useSelector, который может возвращать устаревшие данные в колбэках,
 * этот хук всегда возвращает свежие данные из store.
 *
 * @param selector - функция селектора для получения данных из store
 * @returns функция, которая возвращает актуальное значение из store
 */
export const useCurrentSelector = <T>(selector: (state: IApplicationState) => T): (() => T) => {
  const store = useStore();

  return useCallback(() => {
    return selector(store.getState() as IApplicationState);
  }, [selector, store]);
};
